export * from './customer/default/brandIcon.constants';

export const DEFAULT_ALPHA = 0.001;
